import {
    GET_ASSETS,
    ASSETS_REQUEST,
    ASSETS_STATS_REQUEST,
    ADD_ASSET,
    EDIT_ASSET,
    DELETE_ASSET,
    SET_USERS,
    SET_LOADING,
    SET_ERROR,
    ASSETS_DATA,
    SET_LOCATIONS
} from '../actions/assetActions';

const initialState = {
    assets: [],
    assetsScopeKey: null,
    users: [],
    locations: [],
    loading: false,
    statsLoading: false,
    error: null,
    assets_stat_data: [],
};

export default function assetReducer(state = initialState, action) {
    switch (action.type) {
        case ASSETS_REQUEST: {
            const isScopeChange =
                action.scopeKey != null && action.scopeKey !== state.assetsScopeKey;
            return {
                ...state,
                assets: isScopeChange ? [] : state.assets,
                assets_stat_data: isScopeChange ? [] : state.assets_stat_data,
                assetsScopeKey: action.scopeKey ?? state.assetsScopeKey,
                loading: true,
                error: null,
            };
        }
        case ASSETS_STATS_REQUEST: {
            // Fetching stats shouldn't flip the list's own loading flag —
            // that flag drives the asset list/table's loading UI, and stats
            // fire on every overlay open, which was flickering the list.
            const isScopeChange =
                action.scopeKey != null && action.scopeKey !== state.assetsScopeKey;
            return {
                ...state,
                assets_stat_data: isScopeChange ? [] : state.assets_stat_data,
                assetsScopeKey: action.scopeKey ?? state.assetsScopeKey,
                statsLoading: true,
                error: null,
            };
        }
        case GET_ASSETS:
            if (
                action.scopeKey != null &&
                state.assetsScopeKey != null &&
                action.scopeKey !== state.assetsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                assets: action.payload,
                assetsScopeKey: action.scopeKey ?? state.assetsScopeKey,
                loading: false,
                error: null
            };
        case ADD_ASSET:
            return {
                ...state,
                assets: [...state.assets, action.payload],
                loading: false,
                error: null
            };
        case EDIT_ASSET:
            return {
                ...state,
                assets: state.assets.map(asset =>
                    asset.id === action.payload.id ? action.payload : asset
                ),
                loading: false,
                error: null
            };
        case DELETE_ASSET:
            return {
                ...state,
                assets: state.assets.filter(asset => asset.id !== action.payload),
                loading: false,
                error: null
            };
        case SET_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };
        case SET_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case SET_USERS:
            return {
                ...state,
                users: action.payload,
                loading: false,
                error: null
            };

        case ASSETS_DATA:
            if (
                action.scopeKey != null &&
                state.assetsScopeKey != null &&
                action.scopeKey !== state.assetsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                assets_stat_data: action.payload,
                assetsScopeKey: action.scopeKey ?? state.assetsScopeKey,
                statsLoading: false,
            };
        case SET_LOCATIONS:
            return {
                ...state,
                locations: action.payload,
            };
        default:
            return state;
    }
}